// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".ndoiz {\n  display: block;\n  text-align: right;\n  margin-top: 4px;\n  font-size: 14px;\n  font-family: var(--font-family-body);\n  color: var(--color-font);\n}\n\n.icV8O {\n  color: var(--color-blue);\n  text-decoration: underline;\n}\n\n.icV8O:hover {\n  cursor: pointer;\n}\n\n.P21He {\n  cursor: default;\n}\n", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": "ndoiz",
	"link": "icV8O",
	"text": "P21He"
};
export default ___CSS_LOADER_EXPORT___;
